import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=297b1f6a&scoped=true&"
import script from "./Savings.vue?vue&type=script&lang=js&"
export * from "./Savings.vue?vue&type=script&lang=js&"
import style0 from "./Savings.vue?vue&type=style&index=0&id=297b1f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b1f6a",
  null
  
)

export default component.exports